import React from 'react';

export default function MatchName(props: { name: string }) {
  const { name } = props;

  return <div id='current-tournament-container'>{name}</div>;
}
